import { SorterResult } from 'antd/es/table/interface';
import { Holiday, HolidayFilterParams } from '@/types/admin-holiday';
import { AppBreadcrumb, AppContainer } from '../atoms';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import AdminHolidayFilter from '../molecules/AdminHolidayFilter';
import HolidayTable from '../molecules/HolidayTable';

interface AdminHolidayListTemplateProps {
  data: Holiday[];
  sortInfo?: {
    columnKey?: string;
    order?: 'ascend' | 'descend';
  };
  onTableChange?: (sorter: SorterResult<Holiday> | SorterResult<Holiday>[]) => void;
  onSearch?: (filters: HolidayFilterParams) => void;
  onCsv?: () => void;
  csvLoading?: boolean;
  breadcrumbItems: BreadcrumbItemType[];
  isLoading?: boolean;
}

const AdminHolidayListTemplate = ({
  data,
  isLoading,
  sortInfo,
  onTableChange,
  onSearch,
  onCsv,
  csvLoading,
  breadcrumbItems,
}: AdminHolidayListTemplateProps) => {
  return (
    <AppContainer>
      <main className="space-y-5 px-4">
        <AppBreadcrumb items={breadcrumbItems} />
        <h3 className="text-xl">休日</h3>
        <AdminHolidayFilter onSearch={onSearch} onCsv={onCsv} csvLoading={csvLoading} />
        <div className="bg-white rounded-md border">
          <HolidayTable
            data={data}
            sortInfo={sortInfo}
            onTableChange={onTableChange}
            isLoading={isLoading}
          />
        </div>
      </main>
    </AppContainer>
  );
};

export default AdminHolidayListTemplate;
